export default (fetch: typeof $fetch) => ({
  submitOptIn: async ({
    firstName,
    lastName,
    email,
    zip
  }: {
    firstName: string;
    lastName: string;
    email: string;
    zip: string;
  }) => {
    const response = await fetch('rys/v1/thd/promo', {
      method: 'POST',
      body: {
        first_name: firstName,
        last_name: lastName,
        email,
        zip
      }
    });

    return response;
  }
});
